<script>
	import { onMount } from 'svelte';
	import { ethers } from 'ethers';
	import {
		CONTRACT_ADDRESS,
		transformCharacterData,
	} from './components/stores';
	import SelectCharacter from './components/SelectCharacter.svelte';
	import LoadingIndicator from './components/LoadingIndicator.svelte';
	import myEpicGame from './utils/MyEpicGame.json';
	import Arena from './components/Arena.svelte';
	const twitterLogo = './twitter-logo.svg';
	let currentAccount = null;
	let characterNFT = null;
	let isLoading = false;

	onMount(async () => {
		isLoading = true;

		console.log('checkIfWalletIsConnected');
		try {
			const { ethereum } = window;

			if (!ethereum) {
				console.log('Make sure you have MetaMask!');
				isLoading = false;
				return;
			} else {
				console.log('We have the ethereum object', ethereum);
			}

			const accounts = await ethereum.request({ method: 'eth_accounts' });

			/*
			 * User can have multiple authorized accounts, we grab the first one if its there!
			 */
			if (accounts.length !== 0) {
				const account = accounts[0];
				console.log('Found an authorized account:', account);
				currentAccount = account;
				// console.log('CurrentAccount:', currentAccount);
				// fetchNFTMetadata();
			} else {
				console.log('No authorized account found', currentAccount);
			}
		} catch (error) {
			console.log(error);
		}
		isLoading = false;
	});

	const fetchNFTMetadata = async () => {
		console.log('Checking for Character NFT on address:', currentAccount);

		const provider = new ethers.providers.Web3Provider(window.ethereum);
		const signer = provider.getSigner();
		const gameContract = new ethers.Contract(
			$CONTRACT_ADDRESS,
			myEpicGame.abi,
			signer
		);

		const _characterNFT = await gameContract.checkIfUserHasNFT();
		if (_characterNFT.name) {
			console.log('User has character NFT');
			characterNFT = transformCharacterData(_characterNFT);
			isLoading = false;
		} else {
			console.log('No character NFT found');
		}
	};

	/*
	 * We only want to run this, if we have a connected wallet
	 */
	$: if (currentAccount != null) {
		console.log('CurrentAccount:', currentAccount);
		fetchNFTMetadata();
	}

	const connectWalletAction = async () => {
		try {
			const { ethereum } = window;

			if (!ethereum) {
				alert('Get MetaMask!');
				return;
			}

			/*
			 * Fancy method to request access to account.
			 */
			const accounts = await ethereum.request({
				method: 'eth_requestAccounts',
			});

			/*
			 * Boom! This should print out public address once we authorize Metamask.
			 */
			console.log('Connected', accounts[0]);
			currentAccount = accounts[0];
		} catch (error) {
			console.log(error);
		}
	};
</script>

<main>
	<div class="container">
		<div class="header-container">
			<p class="header gradient-text">🪄 The Dark Lord Slayer 🪄</p>
			<p class="sub-text">
				Team up to cast spells against he who shall not be named!
			</p>
			{#if isLoading}
				<LoadingIndicator />
			{:else if !currentAccount}
				<div class="connect-wallet-container">
					<img
						src="https://i.giphy.com/Uc63DLTrbmqvS.gif"
						alt="Harry Potter Gif"
					/>
					<button
						class="cta-button connect-wallet-button"
						on:click={connectWalletAction}
					>
						Connect Wallet To Get Started
					</button>
				</div>
			{:else if currentAccount && !characterNFT}
				<SelectCharacter bind:characterNFT />
			{:else if currentAccount && characterNFT}
				<Arena {characterNFT} />
			{/if}
		</div>
		<div class="footer-container">
			<img alt="Twitter Logo" class="twitter-logo" src={twitterLogo} />
			<a
				class="footer-text"
				href="https://twitter.com/designs_athena"
				target="_blank"
				rel="noreferrer">{`built with @designs_athena`}</a
			>
		</div>
	</div>
</main>

<style>
	main {
		height: 100vh;
		background-color: #7471b0;
		overflow: scroll;
		text-align: center;
	}

	.container {
		height: 100%;
		background-color: #7471b0;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.header-container {
		padding-top: 30px;
	}

	.header {
		margin: 0;
		font-size: 50px;
		font-weight: bold;
		color: white;
	}

	.sub-text {
		font-size: 25px;
		color: white;
	}

	/* .content-container {
		background-color: #a200d6;
	} */

	.cta-button {
		height: 45px;
		border: 0;
		width: auto;
		padding-left: 40px;
		padding-right: 40px;
		border-radius: 5px;
		cursor: pointer;
		font-size: 16px;
		font-weight: bold;
		color: white;
	}

	.connect-wallet-container {
		display: flex;
		flex-direction: column;
		margin: auto;
		max-width: 550px;
	}

	.connect-wallet-container img {
		padding-bottom: 20px;
	}

	.connect-wallet-button {
		background-image: linear-gradient(
			to right,
			#ff8177 0%,
			#ff867a 0%,
			#ff8c7f 21%,
			#f99185 52%,
			#cf556c 78%,
			#b12a5b 100%
		);
		background-size: 200% 200%;
		animation: gradient-animation 4s ease infinite;
	}

	/* .mint-button {
		background: -webkit-linear-gradient(left, #a200d6, #ff6fdf);
		background-size: 200% 200%;
		animation: gradient-animation 4s ease infinite;
		margin-right: 15px;
	} */

	/* .opensea-button {
		background-color: rgb(32, 129, 226);
	} */

	/* .mint-count {
		color: white;
		font-size: 18px;
		font-weight: bold;
	} */

	.footer-container {
		display: flex;
		justify-content: center;
		align-items: center;
		padding-bottom: 30px;
	}

	.twitter-logo {
		width: 35px;
		height: 35px;
	}

	.footer-text {
		color: white;
		font-size: 16px;
		font-weight: bold;
	}

	/* KeyFrames */
	@-webkit-keyframes gradient-animation {
		0% {
			background-position: 0% 50%;
		}
		50% {
			background-position: 100% 50%;
		}
		100% {
			background-position: 0% 50%;
		}
	}
	@-moz-keyframes gradient-animation {
		0% {
			background-position: 0% 50%;
		}
		50% {
			background-position: 100% 50%;
		}
		100% {
			background-position: 0% 50%;
		}
	}
	@keyframes gradient-animation {
		0% {
			background-position: 0% 50%;
		}
		50% {
			background-position: 100% 50%;
		}
		100% {
			background-position: 0% 50%;
		}
	}
</style>
